import React, { Component } from 'react';
import Proptypes from 'prop-types';
import { Modal, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';

import Loader from 'dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent';

import './DialogTalkToExpert.css';



class DialogTalkToExpert extends Component {

    constructor(props) {
        super(props);

        this.state = {
            query: '',
            showError: false,
            showSuccess: false
        };

        this.onQueryChanged = this.onQueryChanged.bind(this);
    }


    // Lifecycle Methods

    render() {
        return (
        <Modal show={this.props.open} onHide={this.props.onClose}>
            
            <Modal.Header closeButton>
                <Modal.Title><span className="hsg-dte-title-text">TALK TO A HEALTHSETGO EXPERT</span></Modal.Title>
            </Modal.Header>


            {!this.state.showSuccess ?
            <Modal.Body>

                <p className="hsg-dte-subtitle-text">Call Us At +91-955-555-33-11</p>

                <div style={{height: 30}} />


                <FormGroup controlId="form-dialog-text-query">

                    <ControlLabel>OR ENTER YOUR QUERY HERE</ControlLabel>

                    <FormControl
                        componentClass="textarea"
                        value={this.state.query}
                        onChange={this.onQueryChanged}
                        style={{height: 150}} />

                </FormGroup>


                {this.props.isLoading ?
                    <div style={{padding: 20}}><Loader /></div>
                    
                :
                
                    <div style={{textAlign: 'end'}}>
                        <span className="hsg-dte-button-submit" onClick={() => this.onSubmit()}>
                            SUBMIT
                        </span>

                        {this.state.showError && <div style={{marginTop: 10}}>{this.props.error}</div>}
                    </div>}

            </Modal.Body>
            
            :
            
            <Modal.Body>
                <p className="hsg-dte-subtitle-text">Your Query was posted Successfully</p>
            </Modal.Body>}

        </Modal>);
    }


    componentDidMount() {
        this.props.resetExpertQuery();
    }


    componentWillReceiveProps(newProps) {
        if(!newProps.isLoading && this.props.isLoading) {
            if(newProps.postStatus) {
                this.setState({showSuccess: true});
            }

            else {
                this.setState({showError: true});
            }
        }
    }


    // Event Listeners

    onQueryChanged(e) {
        this.setState({query: e.target.value});
    }

    onSubmit() {
        if(Boolean(this.state.query)) {
            const params = {
                studentId: this.props.childList[this.props.selectedChild].uuId,
                parentId: this.props.user.uuId,
                parentQuery: this.state.query
            };

            this.props.postExpertQuery(params);

            this.setState({showError: false});
        }
    }

}



DialogTalkToExpert.propTypes = {
    open: Proptypes.bool.isRequired,
    onClose: Proptypes.func.isRequired
};



export default DialogTalkToExpert